import { useConfigurationStore } from '@/Store/storeConfiguration';
import { useStoreData } from '@/Store/storeData';
import { useUIOnlyStore } from '@/Store/storeUI';

export function replaceItemsOnColorChange() {
    const itemIDs = useConfigurationStore().getAllItemIDs;
    const sceneItems = useStoreData().getItemsByIdArr(itemIDs);
    const allItems = useStoreData().getAllItems;
    const wardrobeColor = useConfigurationStore().getWardrobeBaseColor.replace('#', '');
    const itemsOfColor = allItems.filter((item) => item.color.hex === wardrobeColor.replace('#', ''));

    let blenderName = '';
    let match;
    let rule = {};
    let names = {};
    let modules = JSON.parse(JSON.stringify(useConfigurationStore().getModules));
    let shelves = JSON.parse(JSON.stringify(useConfigurationStore().getShelves));
    let rails= JSON.parse(JSON.stringify(useConfigurationStore().getRails));
    let accessories= useStoreData().getCategoriesItems;
    let selectedObject = useUIOnlyStore().selectedSceneObject;
    let selectedObjectName = 'Выделение';
    for (let item of sceneItems) {
        blenderName = item.blender_name;
        if(blenderName) match = itemsOfColor.filter((item) => item.blender_name === blenderName)[0];
        if (match&&(blenderName!==null)) {
            rule[item.id] = match.id;
            names[match.blender_name] = match.name;
        }
    }

    // update modules by rule
    for (let module of modules) {
        module.color = wardrobeColor;
        module.templates.forEach((rack)=> {
            if (!rack.id) return;
            rack.id = rule[module.templates[0].id];
            rack.color = wardrobeColor;
        });
        // module.templates.rack.id = rule[module.templates.rack.id];
        // module.templates.rack.color = wardrobeColor;
    }
    for (let shelf of shelves) {
        shelf.humanName = names[
        shelf.templates.panel?.blender_name??
        shelf.templates.shelf?.blender_name??
        shelf.templates.basket?.blender_name??
        shelf.templates.trouserRack?.blender_name??
        shelf.templates.rod?.blender_name];

        shelf.color=wardrobeColor;
        if(shelf.uuid === selectedObject.uuid) {
            selectedObjectName = shelf.humanName;
        }
        for (let i in shelf.templates) {
            if (Array.isArray(shelf.templates[i])) {
                shelf.templates[i].forEach((item)=> {
                    if(
                        item.id &&
                        ![ 'rodCap', 'rod', 'rodConnector' ].includes(item.type)) {
                            item.id = rule[item.id];
                            item.color = wardrobeColor;
                    }
                });
            }
            if(rule[shelf.templates[i].id]){
                shelf.templates[i].id = rule[shelf.templates[i].id];
                shelf.templates[i].color = wardrobeColor;
            }
        }
    }

    for (let rail of rails) {
        rail.color = wardrobeColor;
        for (let i in rail.templates) {
            if (Array.isArray(rail.templates[i])) {
                rail.templates[i].forEach((item)=>{
                    item.id = rule[rail.templates[i].id];
                    item.color = wardrobeColor;
                });
            }
            rail.templates[i].id = rule[rail.templates[i].id];
            rail.templates[i].color = wardrobeColor;
        }
    }

    if(accessories['111']||accessories['110']){
        if(wardrobeColor==='5e5e5e')accessories={ '111':accessories['110']??accessories['111'] };
        if(wardrobeColor==='ffffff')accessories={ '110':accessories['111']??accessories['110'] };
        useStoreData().categoriesItems=accessories;
    }

    useConfigurationStore().updateModules(modules);
    useConfigurationStore().updateRails(rails);
    useConfigurationStore().updateShelves(shelves);


    //useUIOnlyStore().unselect(); // unselect?

    // update selected object
    if (selectedObject.label !== 'Выделение') {
        selectedObject.label = selectedObjectName;
    }
    useUIOnlyStore().setSelectedSceneObject(selectedObject.uuid, selectedObject.label, selectedObject.text);
    match=null;
}
